module.exports = __webpack_public_path__ + "static/fonts/Roboto Slab Regular.f0357a11.eot";